<template>
    <div class="emoji-picker-wrapper">
    <emoji-picker ref="picker"></emoji-picker>
  </div>
</template>

<script>
    import 'lib/emoji-picker-element'
    import de from 'lib/emoji-picker-element/i18n/de'

    export default {
        mounted() {
            this.setLanguage()
            this.$refs.picker.addEventListener('emoji-click', this.handleEmoji)
        },

        beforeDestroy() {
            this.$refs.picker.removeEventListener('emoji-click', this.handleEmoji)
        },

        methods: {
            handleEmoji(event) {
                this.$emit('onSelect', event.detail.unicode)
            },

            setLanguage() {
                this.$refs.picker.i18n = de
                this.$refs.picker.locale = de
                this.$refs.picker.dataSource = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@1.8.0/de/cldr/data.json'
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '_assets/emojipicker';
</style>